module.exports = "/_next/static/images/Frame-7a6eb91742fedcf16f70560ca3bb74dd.png";